<div *ngIf="breadcrumbs" [class]="'page-header mb-3 '+ (headerClass?headerClass:'') ">
    <div class="container flex flex-col sm:flex-row justify-between items-center">
        <div *ngIf="!subCategroies?.length" class=" mobile:hidden page-header__containerr  breadcrumbs">
            <div class="page-header__breadcrumb">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <ng-container *ngFor="let breadcrumb of breadcrumbs; last as last">
                            <li *ngIf="!last" class="breadcrumb-item">
                                <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
                                <app-icon class="breadcrumb-arrow" name="arrow-rounded-right-6x9" size="6x9"></app-icon>
                            </li>
                            <li *ngIf="last" class="breadcrumb-item active" aria-current="page">{{ breadcrumb.label }}
                            </li>
                        </ng-container>
                    </ol>
                </nav>
            </div>
            <div *ngIf="header" class="page-header__title">
                <h1>{{ header }}</h1>
            </div>
        </div>
        <div *ngIf="subCategroies?.length" class="mt-1 sub-carousel mobile:hidden">
            <ng-container *ngIf="subCategroies?.length > 0">

                <owl-carousel-o appOwlPreventClick *ngIf="subCategroies && subCategroies.length > 0"
                    [options]="carouselOptions">
                    <ng-template carouselSlide *ngFor="let category of subCategroies"
                        [width]="category.width || category.chipWidth || 150">
                        <a appclick [routerLink]="['/',currentLang, 'category', category.seo?.slug]">
                            <div class="category-label block-subCategroies__item cursor-pointers"
                                (click)="selectedcategory = category.seo?.slug"
                                [class.active]="selectedcategory && selectedcategory == category?.seo?.slug">
                                {{translateHelper.localize(category.name)}}
                            </div>
                        </a>
                    </ng-template>
                </owl-carousel-o>
            </ng-container>

        </div>
        <div *ngIf="showSearch" class="search">
            <app-search [location]="'page-header'"></app-search>
        </div>
    </div>


</div>